import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'tss-react/mui';
import Paper from '@mui/material/Paper';

import CustomAddress from '../CustomInputs/CustomAddress';

const styles = theme => ({
  inputRWDInvoice: {
    position: 'absolute',
    top: '2em',
    right: '4em',
    width: '40%',
    height: '9%',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      top: '-15px',
      left: '10px',
      width: '95%',
    }
  }
});

class AddressAutoComplete extends PureComponent {
  render() {
    const { setAddress, classes, updateAddress, address } = this.props;
    return (
      <Paper elevation={3}
        className={classes.inputRWDInvoice}>
        <CustomAddress
          style={{
            margin: '4px 10px',
            width: 'calc(100% - 20px)',
          }}
          classes={classes.customAddress}
          updateAddress={updateAddress}
          setAddress={setAddress}
          address={address}
          placeholder='Adresse de facturation'
        />
      </Paper>
    );
  }
}

AddressAutoComplete.propTypes = {
  setAddress: PropTypes.func.isRequired
};

export default withStyles(AddressAutoComplete, styles);
